const COLORS = {
    orange: "#ffa31a",
    grey: "#808080",
    black: "#292929",
    darkBlack: "#1b1b1b",
    white: "#ffffff"
}

export default COLORS;